import { useEffect, useState } from 'react';
import Config from '../../../../axios/Config';
import { SCAN } from '../../../../constants/routes';
import {
  notifyError,
  notifySuccess,
  notifyWarning,
} from '../../../../utils/Notify';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import FidScanScreen from './FidScanScreen';
import { addFidCard } from '../../../../actions/userFidelityActions';

const LoginAddFidScanScreen = () => {
  const navigate = useNavigate();
  const axiosInstance = Config();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const { cartItems } = useSelector((state) => state.cart);
  const { store } = useSelector((state) => state.store);
  const [recaptchaResultToken, setRecaptchaResultToken] = useState('');
  const [fidelityCardId, setFidelityCardId] = useState(undefined);
  const location = useLocation();
  const image = location?.state?.image;
  
  const onAddFidCardSuccess = (fidCardNum, data) => {
    if (data?.fidCard[0]?.fidelityInfo?.statutIdentification === 'OK') {
      navigate(SCAN, { state: { fidCardNum: fidCardNum } });
      notifySuccess('Carte ajoutée !');
    } else {
      notifyError("Erreur lors de l'ajout de la carte");
    }
  };

  const login = (fidCardNum) => {
    if (!fidCardNum) {
      notifyWarning('Il faut saisir un numéro de carte de fidélité.');
      return;
    }
    dispatch(
      addFidCard(
        axiosInstance,
        user,
        cartItems,
        fidCardNum,
        recaptchaResultToken,
        (data) => onAddFidCardSuccess(fidCardNum, data),
      ),
    );
  };

  useEffect(() => {
    if (fidelityCardId) {
      login(fidelityCardId);
      setFidelityCardId(undefined); // To re initialize scanner behavior
    }
  }, [fidelityCardId]);

  return (
    <FidScanScreen
      onConfirm={login}
      onScan={setFidelityCardId}
      fidScanLoading={user.userLoading}
      goToCardScreen={() => navigate(-1)}
      companyLogo={image}
      companyName={store?.name}
      setRecaptchaResultToken={setRecaptchaResultToken}
    />
  );
};

export default LoginAddFidScanScreen;
